import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FLEX_COMPAT_DIRECTIVES} from './flex-compat.directives';

/**
 * Reemplazo drop-in de FlexLayoutModule para el subconjunto de directivas fx*
 * que usa el proyecto. Se importa/exporta desde SharedModule igual que antes
 * FlexLayoutModule, así todos los templates siguen funcionando sin cambios.
 */
@NgModule({
  imports: [CommonModule],
  declarations: [...FLEX_COMPAT_DIRECTIVES],
  exports: [...FLEX_COMPAT_DIRECTIVES]
})
export class FlexCompatModule {
}
